import type { IModalBarProps } from "@bonusx-global/bx-design-system";
import { ModalBar } from "@bonusx-global/bx-design-system";
import { TimesSolid } from "@bonusx-global/bx-icons";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function HeaderModalBar(props: Readonly<IModalBarProps>): JSX.Element {
  const navigate = useNavigate();

  const onClickToCloseCallback = useCallback(
    function onClickToClose() {
      // In React Router v6, we can't check history.length, so we always navigate back
      // If there's no history, navigate will go to home
      navigate(-1);
    },
    [navigate]
  );

  return <ModalBar endIcon={<TimesSolid />} onEndIconClick={onClickToCloseCallback} {...props} />;
}
